module.exports = __webpack_public_path__ + "static/img/cDR7.95bf65d3.png";